/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React, {useEffect, useState} from 'react';
import Header from '../Header/Header';
import AccessCodeExternal from './AccessCodeExternal/AccessCodeExternal';
import './ValidateIdentityExternal.scss';

export default function ValidateIdentityExternal() {
  const [isVisible, setIsVisible] = useState(false);
  const pageName = 'Validate Identity';

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  });

  return (
    <>
      <Header pageName={pageName}/>
      <div className={`fade-in ${isVisible ? 'visible' : ''}`}>
        {isVisible && <AccessCodeExternal pageName={pageName}/>}
      </div>
    </>
  );
}
